import {
  SiSpringboot,
  SiJavascript,
  SiTypescript,
  SiHtml5,
  SiCss,
  SiMysql,
  SiMongodb,
  SiAngular,
  SiHibernate,
  SiJunit5,
  SiPostman,
  SiSwagger,
  SiDocker,
  SiKubernetes,
  SiJenkins,
  SiApachemaven,
  SiGradle,
  SiGit,
  SiGithub,
  SiSonarqubeserver,
  SiIntellijidea,
  SiEclipseide,
} from "react-icons/si";

import { FaJava, FaAws } from "react-icons/fa";

import {
  Network,
  ShieldCheck,
  KeyRound,
  Layers,
  Code,
  Database,
} from "lucide-react";

// Each item: { name, Icon, color }
export const SKILL_ROWS = [
  // Row 1 — Languages & Frontend
  [
    { name: "Java", Icon: FaJava, color: "#007396" },
    { name: "JavaScript", Icon: SiJavascript, color: "#F7DF1E" },
    { name: "TypeScript", Icon: SiTypescript, color: "#3178C6" },
    { name: "HTML5", Icon: SiHtml5, color: "#E34F26" },
    { name: "CSS3", Icon: SiCss, color: "#1572B6" },
    { name: "Angular", Icon: SiAngular, color: "#DD0031" },
    { name: "SQL", Icon: SiMysql, color: "#4479A1" },
  ],

  // Row 2 — Backend / Spring Ecosystem
  [
    { name: "Spring Boot", Icon: SiSpringboot, color: "#6DB33F" },
    { name: "Spring MVC", Icon: SiSpringboot, color: "#6DB33F" },
    { name: "Spring Security", Icon: ShieldCheck, color: "#6DB33F" },
    { name: "Spring Data JPA", Icon: Layers, color: "#6DB33F" },
    { name: "Hibernate", Icon: SiHibernate, color: "#59666C" },
    { name: "JWT Auth", Icon: KeyRound, color: "#FB015B" },
    { name: "RESTful APIs", Icon: Network, color: "#22D3EE" },
    { name: "Microservices", Icon: Code, color: "#8B5CF6" },
  ],

  // Row 3 — Databases, Cloud & Tools
  [
    { name: "Oracle", Icon: Database, color: "#F80000" },
    { name: "MySQL", Icon: SiMysql, color: "#4479A1" },
    { name: "MongoDB", Icon: SiMongodb, color: "#47A248" },
    { name: "Docker", Icon: SiDocker, color: "#2496ED" },
    { name: "Kubernetes", Icon: SiKubernetes, color: "#326CE5" },
    { name: "AWS (EC2)", Icon: FaAws, color: "#FF9900" },
    { name: "Jenkins", Icon: SiJenkins, color: "#D24939" },
    { name: "Maven", Icon: SiApachemaven, color: "#C71A36" },
    { name: "Gradle", Icon: SiGradle, color: "#02303A" },
    { name: "JUnit", Icon: SiJunit5, color: "#25A162" },
    { name: "Postman", Icon: SiPostman, color: "#FF6C37" },
    { name: "Swagger", Icon: SiSwagger, color: "#85EA2D" },
    { name: "Git", Icon: SiGit, color: "#F05032" },
    { name: "GitHub", Icon: SiGithub, color: "#E5E7EB" },
    { name: "SonarQube", Icon: SiSonarqubeserver, color: "#4E9BCD" },
    { name: "IntelliJ IDEA", Icon: SiIntellijidea, color: "#000000" },
    { name: "Eclipse", Icon: SiEclipseide, color: "#2C2255" },
  ],
];

// scale jitter (5-10%) so the row feels organic
export const sizeJitter = (seed) => {
  const v = ((seed * 9301 + 49297) % 233280) / 233280;
  return 0.94 + v * 0.12;
};
